import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import AppRouter from './App';
import * as serviceWorker from './serviceWorker';
import { history } from './store';
import { BrowserRouter } from 'react-router-dom';
ReactDOM.render(
  <BrowserRouter>
    <AppRouter history={history} />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
